/**
* Featured Pets JS
* -----------------------------------------------------------------------------
*
* All the JS for the Featured Pets component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';
( function( app ) {
  const COMPONENT = {

    className: 'featured-pets',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      if ( $( '.featured-pets' ).length ) {
        $( '.featured-pets' ).each( function() {
          const sliders = {};
          $( '.featured-pets__splide' ).each( function( index, element ) {
            const slider = new Splide( element, {
              type: 'slide',
              gap: '1.25rem',
              perPage: 4,
              perMove: 1,
              pagination: false,
              breakpoints: {
                1024: {
                  perPage: 2,
                },
                768: {
                  perPage: 1,
                },
              },
            } );
            const progressBar = slider.root.querySelector( '.featured-pets__progress-bar' );
            const progressAmount = slider.root.querySelector( '.featured-pets__progress-amount' );
            // Updates the bar width whenever the carousel moves:
            slider.on( 'mounted move', function() {
              const slideCount = slider.Components.Slides.getLength();
              const end = slider.Components.Controller.getEnd() + 1;
              const rate = Math.min( ( slider.index + 1 ) / end, 1 );
              progressBar.style.width = String( 100 * rate ) + '%';

              /* ADA updates sr-only text of progress bar */
              if ( slideCount >= 3 ) {
                $( progressAmount ).text( `${slider.index + 3} of ${slideCount} cards` );
              } else {
                $( progressAmount ).text( `${slideCount} of ${slideCount} cards` );
              }
            } );
            slider.mount();

            const sliderId = $( this ).attr( 'id' );

            sliders[sliderId] = slider;
            $( '.slider-tab-button[data-toggle-target="#' + sliderId + '"]' ).on( 'click', function() {
              slider.refresh();
            } );
          } );

          let currentSlider = $( this ).find( '.featured-pets__splide.is-open' ).attr( 'id' );
          const select = $( this ).find( '.featured-pets__select' );
          const announcement = $( this ).find( '.featured-pets__announcement' );

          $( document ).on( 'change', '.js-featured-pets-form', function( event ) {
            event.preventDefault();
            const formData = $( this ).serializeArray();

            let updatedSlider = currentSlider;
            let inputType = '';

            $( formData ).each( function( index, value ) {
              if ( value.value !== currentSlider ) {
                updatedSlider = value.value;
                inputType = value.name;
              }
            } );

            /* Show the slider and update aria attribute */
            $( `#${currentSlider}` ).removeClass( 'is-open' );
            $( `#${currentSlider}` ).attr( 'aria-hidden', true );
            $( `#${updatedSlider}` ).addClass( 'is-open' );
            $( `#${updatedSlider}` ).attr( 'aria-hidden', false );

            currentSlider = updatedSlider;

            /* refresh selected slider so the splide arrows and progress bar are displayed */
            sliders[currentSlider].refresh( );

            /* make sure form fields have same value */
            if ( inputType === 'featured-service-select' ) {
              $( this ).find( `.featured-pets__radio-input[value="${currentSlider}"]` ).prop( 'checked', true );
            } else {
              select.val( currentSlider );
            }

            /* announce the slider has been displayed */
            const selectedTitle = $( `#${select.attr( 'id' )} option:selected` ).text();
            announcement.text( `${selectedTitle} slider is displayed` );

            return false;
          } );
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'featured-pets', COMPONENT );
} )( app );
